import type { RegisteredServices } from '@/core/container/types'
import type { TmWrappers } from '@/wrappers'

export const WhatsAppAccountsTable = 'WhatsAppAccountsTable' as RegisteredServices

export const WhatsAppAccountPhonesTable = 'WhatsAppAccountPhonesTable' as RegisteredServices

export const whatsAppViewQrCodeModalId: TmWrappers = 'whatsAppViewQrCodeModal'

export type WhatsAppViewQrCodeModalParams = {
  phone: string
  displayName: string
  url: string
  link?: string
}
